const centerDiagramInScrollContainer = (scrollContainer, diagramElement, toolbarElement) => {
  if (!scrollContainer || !diagramElement) return;

  const containerRect = scrollContainer.getBoundingClientRect();
  const diagramRect = diagramElement.getBoundingClientRect();

  let visibleTop = containerRect.top;
  const visibleBottom = containerRect.bottom;

  if (toolbarElement) {
    const toolbarRect = toolbarElement.getBoundingClientRect();
    if (toolbarRect.bottom > containerRect.top) {
      visibleTop = Math.max(visibleTop, toolbarRect.bottom);
    }
  }

  const visibleCenterX = containerRect.left + containerRect.width / 2;
  const visibleCenterY = visibleTop + (visibleBottom - visibleTop) / 2;

  const diagramCenterX = diagramRect.left + diagramRect.width / 2;
  const diagramCenterY = diagramRect.top + diagramRect.height / 2;

  scrollContainer.scrollLeft += diagramCenterX - visibleCenterX;
  scrollContainer.scrollTop += diagramCenterY - visibleCenterY;
};

export default centerDiagramInScrollContainer;
